import { Reveal } from "./Reveal";
import { Apple, Sprout, HandHeart, Heart } from "lucide-react";

const Pantry = () => (
  <section id="pantry" className="py-28 lg:py-36 bg-[#F2F4F0]/50 border-y border-[#E2E8E4]/70" data-testid="pantry-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-12 gap-6 lg:gap-12 items-center">
      <Reveal className="col-span-12 lg:col-span-6">
        <p className="text-xs tracking-[0.3em] uppercase text-[#5C7368] mb-6">Food Pantry</p>
        <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A2F24]">
          Food Pantry <em className="text-[#F4A261]">— Coming Soon</em>
        </h2>
        <p className="mt-6 max-w-md text-base leading-relaxed text-[#5C7368]" data-testid="pantry-coming-soon-note">
          We don't have a food pantry open just yet — but it's one of our biggest goals. We're working toward opening a pantry right here in Kissimmee so neighbors can pick up groceries with dignity, always free. Until then, we deliver food boxes directly to families' homes and to neighbors on the streets.
        </p>
        <div className="mt-8 flex items-center gap-3 text-sm text-[#5C7368]">
          <span className="w-11 h-11 rounded-full bg-[#C4D7D1] flex items-center justify-center shrink-0">
            <Apple size={18} className="text-[#1E352A]" />
          </span>
          <p>2886 Running Brook Cir, Kissimmee, Florida</p>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <a href="#donate" data-testid="pantry-donate-btn"
            className="inline-flex items-center gap-2 rounded-full bg-[#1E352A] text-[#FAF9F6] px-7 py-3.5 text-sm tracking-[0.12em] uppercase transition-colors duration-300 hover:bg-[#F4A261] hover:text-white">
            <Heart size={15} /> Help Us Open It
          </a>
          <a href="#volunteer" data-testid="pantry-volunteer-btn"
            className="inline-flex items-center gap-2 rounded-full border border-[#1E352A]/25 text-[#1E352A] px-7 py-3.5 text-sm tracking-[0.12em] uppercase transition-colors duration-300 hover:border-[#F4A261] hover:text-[#F4A261]">
            <HandHeart size={16} /> Volunteer
          </a>
        </div>
      </Reveal>
      <Reveal delay={0.15} className="col-span-12 lg:col-span-6">
        <div className="rounded-3xl border border-[#E2E8E4] bg-[#FAF9F6] p-10 sm:p-12 text-center shadow-sm" data-testid="pantry-coming-soon-card">
          <span className="inline-flex w-16 h-16 rounded-full bg-[#C4D7D1] items-center justify-center mb-6">
            <Sprout size={28} className="text-[#1E352A]" />
          </span>
          <h3 className="font-display text-3xl text-[#1A2F24]">A pantry in the works</h3>
          <p className="mt-3 text-sm leading-relaxed text-[#5C7368]">
            Your gifts of food, funds, and time bring us closer to opening our doors. Check back soon — we can't wait to share the news.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Pantry;
